import { TripAPI } from '../../../api/datamanager/TripAPI';

export class TripsDraftCommand {
    count(edition, providerId, successCallback, errorCallback) {
        const apiResult = TripAPI.countDraft(edition.network, edition.draftNetwork, edition.draftPlanning, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    getIntervals(edition, tripId, successCallback, errorCallback) {
        const apiResult = TripAPI.getIntervalsWithActiveDraft(edition.network, edition.draftNetwork, edition.draftPlanning, tripId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    getNotes(edition, tripId, successCallback, errorCallback) {
        const apiResult = TripAPI.getNotesWithActiveDraft(edition.network, edition.draftNetwork, edition.draftPlanning, tripId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    moveTrip(sched, tripId, networkEdition, planningEdition, successCallback, errorCallback) {
        const apiResult = TripAPI.moveTripDraft(sched, tripId, networkEdition, planningEdition);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    copyTrip(sched, tripId, networkEdition, planningEdition, successCallback, errorCallback) {
        const apiResult = TripAPI.copyTripDraft(sched, tripId, networkEdition, planningEdition);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    saveIntervals(edition, tripId, intervals, successCallback, errorCallback) {
        const apiResult = TripAPI.saveIntervalsWithActiveDraft(edition.network, edition.draftNetwork, edition.draftPlanning, tripId, intervals);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "[Rascunho] Periodos de Funcionamento guardados com sucesso",
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    saveNotes(edition, tripId, notes, successCallback, errorCallback) {
        const apiResult = TripAPI.saveNotesWithActiveDraft(edition.network, edition.draftNetwork, edition.draftPlanning, tripId, notes);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "[Rascunho] Notas guardadas com sucesso",
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/commands/TripsDraftCommand.js